import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {GridIdentifier} from '@application/grids/grid-identifier.enum';
import {NavigationHelperService} from '@application/helper/navigation-helper/navigation-helper.service';
import {RouteUtils} from '@application/helper/routing/route-utils';
import {PhysicalQuantity} from '@domain/physical-quantity/physical-quantity';
import {PhysicalUnit} from '@domain/physical-quantity/physical-unit';
import {HttpPhysicalQuantitiesService} from '@infrastructure/http/physical-quantity/http-physical-quantities.service';
import {BaseComponent, ColDefBuilderFactoryService, DialogComponentData, GridOptionsBuilderFactoryService, NoDataOverlayComponentParams, OverlayComponentParams} from '@vdw/angular-component-library';
import {AgGridAngular} from 'ag-grid-angular';
import {ColDef, GridApi, GridOptions} from 'ag-grid-community';
import {takeUntil} from 'rxjs';

@Component({
  templateUrl: './select-unit.component.html'
})
export class SelectUnitComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('unitsGrid') public unitsGrid: AgGridAngular;
  public listOfGridOptions: GridOptions[];
  public listOfGridApis: GridApi[];
  public listOfUnits: PhysicalUnit[];

  private physicalQuantityId: number;
  private isCatalog: boolean = false;

  public constructor(
    private readonly physicalQuantityService: HttpPhysicalQuantitiesService,
    private readonly dialogRef: MatDialogRef<SelectUnitComponent>,
    private readonly gridOptionsBuilderFactoryService: GridOptionsBuilderFactoryService,
    private readonly colDefBuilderFactoryService: ColDefBuilderFactoryService,
    private readonly navigationHelperService: NavigationHelperService<DialogComponentData<typeof SelectUnitComponent>>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    super();
    this.physicalQuantityId = data.physicalQuantityId;
    this.isCatalog = data.isCatalog;
  }

  public get gridOptionsForListOfUnits(): GridOptions {
    return this.listOfGridOptions[0];
  }

  public ngOnInit(): void {
    this.setGridOptionsForListOfUnits();
    const request = this.isCatalog ? this.physicalQuantityService.getCatalogById(this.physicalQuantityId) : this.physicalQuantityService.getById(this.physicalQuantityId);
    request.pipe(takeUntil(this.unSubscribeOnViewDestroy)).subscribe((physicalQuantity: PhysicalQuantity) => {
      this.listOfUnits = physicalQuantity.physicalUnits;
    });
  }

  public ngAfterViewInit(): void {
    this.listOfGridApis = [this.unitsGrid?.api];
  }

  public getIsCatalog(): boolean {
    return this.isCatalog;
  }

  public selectUnit(): void {
    this.dialogRef.close(this.unitsGrid.api.getSelectedRows()[0]);
  }

  public canSelectUnit(): boolean {
    return this.unitsGrid?.api?.getSelectedRows().length > 0;
  }

  public navigateToAddUnit(): void {
    this.navigationHelperService.navigateToNextRouteWithPartialState<DialogComponentData<typeof SelectUnitComponent>>(
      {dialogComponent: SelectUnitComponent},
      RouteUtils.paths.settings.physicalQuantity.editPhysicalQuantity.absolutePath.replace(':id', this.physicalQuantityId.toString())
    );
  }

  private setGridOptionsForListOfUnits(): void {
    this.listOfGridOptions = [
      this.gridOptionsBuilderFactoryService
        .getBuilder(this.getColumnDefsForListOfUnits(), GridIdentifier.SELECT_UNIT)
        .withOnCellDoubleClicked(() => this.selectUnit())
        .withLoadingOverlay({
          scale: 0.7
        } as OverlayComponentParams)
        .withNoRowsOverlay({
          scale: 0.7,
          titleParam: 'GENERAL.UNIT.UNIT',
          hideDescription: true
        } as NoDataOverlayComponentParams)
        .build()
    ];
  }

  private getColumnDefsForListOfUnits(): ColDef[] {
    return [
      this.colDefBuilderFactoryService.getBuilder().withField('name', true).withHeaderName('GENERAL.NAME').build(),
      this.colDefBuilderFactoryService.getBuilder().withField('description', true).withHeaderName('GENERAL.DESCRIPTION').build()
    ];
  }
}
